import SignInBackgroundPNG from '@/components/modal/sign-in-modal/sign-in-background/signInBackground.png';
import Image, { type ImageProps } from 'next/image';

export const SignInBackground = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'patient privacy protection', ...rest } = props;
  return <Image src={SignInBackgroundPNG} alt={alt} {...rest} />;
};
